import Button from "../../components/Button";
import { convertToRupiah } from "../../helper/RupiahDashboard";
import { toast } from "react-toastify";
import { Toast } from "../../config/Toast";
import Toggle from "../../components/Toggle";
import moment from "moment";
import MasterBonusService from "../../services/MasterBonus";
import "react-toastify/dist/ReactToastify.css";

const MasterBonusItem = (props) => {
  const data = props;

  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const editHandler = () => {
    props.setModalEdit(true);
    props.setData(props);
  };

  const deleteHandler = () => {
    props.setModalDelete(true);
    props.setData(props);
  };

  const toggleHandler = () => {
    MasterBonusService.updateStatus(props.data.id, {
      is_active: props.data.is_active !== 1 ? 1 : 0,
      updated_by: data.user.id,
    })
      .then(() => {
        setTimeout(() => {
          props.setUpdate(true);
        }, 1000);
        notifySuccess(`Status berhasil diubah`);
      })
      .catch((err) => {
        console.log(err);
        notifyFailed(err.response.data.message);
      });

    data.closeClick();
  };

  return (
    <tr>
      <td>
        <div className="d-flex flex-column w-100 align-items-start">
          <p>{props.no}</p>
        </div>
      </td>
      <td>
        <div className="d-flex flex-column w-100 align-items-start">{props.data.min_attendance}</div>
      </td>
      <td>
        <div className="d-flex flex-column w-100 align-items-start">{props.data.max_attendance || "Tidak Terbatas"}</div>
      </td>
      <td>
        <div className="d-flex flex-column w-100 align-items-start">Rp{convertToRupiah(props.data.amount)}</div>
      </td>
      <td>
        <div className="d-flex flex-column w-100 align-items-start">
          <p className="m-0 p-0 fw-bold">{props.data.created_by || "-"}</p>
          <p className="m-0 p-0">
            {props.data.created_at ? moment(props.data.created_at).format("(DD/MM/YYYY), HH.mm") : "-"}
          </p>
        </div>
      </td>
      <td>
        {props.data.updated_by ? (
          <div className="d-flex flex-column w-100 align-items-start">
            <p className="m-0 p-0 fw-bold">{props.data.updated_by || "-"}</p>
            <p className="m-0 p-0">
              {props.data.updated_at ? moment(props.data.updated_at).format("(DD/MM/YYYY), HH.mm") : "-"}
            </p>
          </div>
        ) : (
          <div className="d-flex flex-column w-100 align-items-start">-</div>
        )}
      </td>
      <td>
        <div className="w-100 p-0 m-0">
          <Toggle checked={props.data.is_active} onClick={toggleHandler} />
        </div>
      </td>
      <td>
        <div className="d-flex justify-content-center align-items-center w-100">
          <div className="d-flex gap-2">
            <Button icon="fa fa-wrench" button="btn-outline-warning btn-sm" onClick={editHandler} />
            <Button icon="fa fa-trash" button="btn-outline-danger btn-sm" onClick={deleteHandler} />
          </div>
        </div>
      </td>
    </tr>
  );
};

export default MasterBonusItem;
